// Product data mapping - maps product names to their details
// PLACEHOLDER: Replace URLs, prices, SKUs, variant IDs, and reviews with real Shopify data before go-live
const PRODUCT_DATA = {
"vitamin c boost serum": {
name: "Vitamin C Boost Serum",
imageUrl: "https://www.smallbatchserums.com/cdn/shop/files/Listing_Images_1D-_Vitamin_C_Serum.jpg",
productUrl: "https://www.smallbatchserums.com/products/vitamin-c-serum",
price: "$28.99",
handle: "vitamin-c-serum",
sku: "VCS",
variantId: "40061556949051",
subtitle: "Three clinically-proven ingredients working together for maximum brightening and protection.",
modalDescription: "Visibly brightens complexion in 2-4 weeks. Reduces appearance of dark spots and hyperpigmentation. Improves skin texture and tone. Provides antioxidant protection against environmental stressors. Lightweight, fast-absorbing formula.",
reviewCount: 16,
review: {
reviewer_name: "Barbara D.",
// skin_type: "PLACEHOLDER_SKIN_TYPE",
review_title: "WOW!",
review_content: "This is a great product! I used the Vitamin C serum and my skin is glowing! I feel it has really helped with my dark spots."
    }
  },
"hyaluronic acid pure boost serum": {
name: "Hyaluronic Acid Pure Boost Serum",
imageUrl: "https://www.smallbatchserums.com/cdn/shop/files/Listing_Images_1B_-_Hyaluronic_Pure_Boost_Serum.jpg",
productUrl: "https://www.smallbatchserums.com/products/hyaluronic-acid-serum",
price: "$28.99",
handle: "hyaluronic-acid-serum",
sku: "HBS",
variantId: "40061556588603",
subtitle: "Powerful hydrating ingredients working together to deliver moisture deep into your skin.",
modalDescription: "Delivers intense, long-lasting hydration. Plumps skin and reduces appearance of fine lines. Boosts skin elasticity and firmness. Locks in moisture for a dewy, supple glow. Lightweight, fast-absorbing formula for all skin types.",
reviewCount: 14,
review: {
reviewer_name: "Maddison A.",
// skin_type: "PLACEHOLDER_SKIN_TYPE",
review_title: "One of the Best HA Serums",
review_content: "As a skincare enthusiast, I have tried countless amounts of hyaluronic acid serums. This one is truly exceptional. My skin feels so hydrated!"
    }
  },
"coenzyme q10 boost serum": {
name: "Coenzyme Q10 Boost Serum",
imageUrl: "https://www.smallbatchserums.com/cdn/shop/files/Listing_Images_1B_-_CoQ10_Boost_Serum.jpg",
productUrl: "https://www.smallbatchserums.com/products/coenzyme-q-10-serum",
price: "$28.99",
handle: "coenzyme-q-10-serum",
sku: "C10S",
variantId: "40061557342267",
subtitle: "Powerful anti-aging ingredients working together to restore youthful, energized skin.",
modalDescription: "Reduces appearance of fine lines and wrinkles. Energizes skin cells for a youthful glow. Promotes firmer, more elastic skin. Provides powerful antioxidant protection. Lightweight, non-greasy formula for all skin types.",
reviewCount: 16,
review: {
reviewer_name: "Susan B.",
// skin_type: "PLACEHOLDER_SKIN_TYPE",
review_title: "Great Products! Great Company!",
review_content: "I love the CoQ10 Boost Serum. I have been ordering this serum for the past year and my skin has never looked better. Highly recommend!"
    }
  }
};
// Helper function to find product data by name (case-insensitive, flexible matching)
function getProductData(productName) {
const normalizedName = productName.toLowerCase().trim();
// Direct match
if (PRODUCT_DATA[normalizedName]) {
return PRODUCT_DATA[normalizedName];
  }
// Partial match - find if the product name contains or is contained in the key
for (const [key, value] of Object.entries(PRODUCT_DATA)) {
if (normalizedName.includes(key) || key.includes(normalizedName)) {
return value;
    }
  }
// Return default/fallback
return {
name: productName,
imageUrl: null,
productUrl: null,
price: null
  };
}
class HairChat extends HTMLElement {
static get observedAttributes() {
return ['test-mode', 'system-prompt', 'model'];
  }
constructor() {
super();
this.messages = [];
this.isTyping = false;
this.conversationHistory = [];
// Generate session ID for tracking in platform
this.sessionId = this.getAttribute('session-id') || `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
// Single AI badge element
this.aiBadge = null;
  }
updateConfig() {
this.testMode = this.getAttribute('test-mode') === 'true' || false;
this.customSystemPrompt = this.getAttribute('system-prompt') || null;
this.customModel = this.getAttribute('model') || null;
  }
attributeChangedCallback(name, oldValue, newValue) {
if (oldValue !== newValue) {
this.updateConfig();
    }
  }
connectedCallback() {
this.initializeComponent();
this.updateConfig();
// Fire GTM event when chat loads
if (typeof window !== 'undefined' && window.dataLayer) {
window.dataLayer.push({
event: 'aichat_started',
session_id: this.sessionId
      });
    }
  }
initializeComponent() {
this.messagesContainer = this.querySelector('.chat-messages');
this.inputField = this.querySelector('.chat-input');
this.sendButton = this.querySelector('.send-button');
this.emptyState = this.querySelector('.empty-state');
this.startOverBtn = this.querySelector('.start-over-btn');
// Get the AI badge from empty state
this.aiBadge = this.querySelector('.expert-badge');
// Only generate modals from JS if not on Shopify (i.e., no Liquid-rendered modals exist)
if (!this.querySelector('[data-product-modal-handle]')) {
this.renderProductModals();
    }
// Get all product modals
this.productModals = this.querySelectorAll('[data-product-modal-handle]');
this.attachEventListeners();
this.initializeProductModals();
this.autoResizeTextarea();
this.updateEmptyStateClass();
  }
attachEventListeners() {
this.sendButton.addEventListener('click', () => this.handleSendMessage());
this.startOverBtn.addEventListener('click', () => this.resetChat());
this.inputField.addEventListener('keydown', (e) => {
if (e.key === 'Enter' && !e.shiftKey) {
e.preventDefault();
this.handleSendMessage();
      }
    });
this.inputField.addEventListener('input', () => this.autoResizeTextarea());
// Event delegation for product clicks and quick-start buttons
this.messagesContainer.addEventListener('click', (e) => {
// Handle product info trigger (opens modal)
const productInfoTrigger = e.target.closest('[data-product-info-trigger]');
if (productInfoTrigger) {
e.preventDefault();
const handle = productInfoTrigger.dataset.productInfoTrigger;
this.showProductModal(handle);
return;
      }
// Handle quick-start button clicks
const quickStartBtn = e.target.closest('.quick-start-btn');
if (quickStartBtn) {
const value = quickStartBtn.dataset.value;
this.handleQuickStartClick(value);
      }
    });
// Handle ATC form submission
this.messagesContainer.addEventListener('submit', (e) => {
const form = e.target.closest('.chat-atc-form');
if (!form) return;
// Fire GTM event
const productSkus = JSON.parse(form.dataset.productSkus || '[]');
if (typeof window !== 'undefined' && window.dataLayer) {
window.dataLayer.push({
event: 'aichat_completed',
session_id: this.sessionId,
product_skus: productSkus,
click_type: 'add_to_cart'
        });
      }
// If <cart-drawer> exists on the page (Shopify), let it intercept the form submit.
const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer) return;
// Fallback for non-Shopify environments: redirect to product URL
e.preventDefault();
const productUrl = form.dataset.productUrl;
if (productUrl) {
window.open(productUrl, '_blank');
      }
    });
  }
initializeProductModals() {
if (!this.productModals || !this.productModals.length) return;
this.productModals.forEach(modal => {
// Close button handlers (X button and Back to Chat button)
const closeBtns = modal.querySelectorAll('[data-modal-close]');
closeBtns.forEach(btn => {
btn.addEventListener('click', () => this.closeProductModal(modal));
      });
// Backdrop click handler
const backdrop = modal.querySelector('[data-modal-backdrop]');
if (backdrop) {
backdrop.addEventListener('click', (e) => {
if (e.target === backdrop) {
this.closeProductModal(modal);
          }
        });
      }
    });
// ESC key handler
document.addEventListener('keydown', (e) => {
if (e.key === 'Escape') {
const openModal = Array.from(this.productModals).find(
modal => !modal.classList.contains('hidden')
        );
if (openModal) {
this.closeProductModal(openModal);
        }
      }
    });
  }
showProductModal(handle) {
const modal = Array.from(this.productModals).find(
m => m.dataset.productModalHandle === handle
    );
if (modal) {
modal.classList.remove('hidden');
document.body.style.overflow = 'hidden';
// Fire GTM event
const productEntry = Object.values(PRODUCT_DATA).find(p => p.handle === handle);
if (typeof window !== 'undefined' && window.dataLayer) {
window.dataLayer.push({
event: 'aichat_product_modal_view',
session_id: this.sessionId,
modal_product_sku: productEntry ? productEntry.sku : handle
        });
      }
    }
  }
closeProductModal(modal) {
modal.classList.add('hidden');
document.body.style.overflow = '';
  }
renderProductModals() {
for (const [key, product] of Object.entries(PRODUCT_DATA)) {
if (!product.handle || !product.modalDescription) continue;
const modalHtml = `
        <div class="product-modal hidden" data-product-modal-handle="${product.handle}">
          <div class="product-modal-backdrop" data-modal-backdrop>
            <div class="product-modal-panel">
              <button class="product-modal-close" data-modal-close aria-label="Close">&times;</button>
              <div class="product-modal-image">
                <img src="${product.imageUrl}" alt="${product.name}">
              </div>
              <div class="product-modal-info">
                <div class="product-modal-rating">
${'★'.repeat(5)} <span class="review-count">(${product.reviewCount || ''})</span>
                </div>
                <h2 class="product-modal-name">${product.name}</h2>
                <p class="product-modal-subtitle">${product.subtitle || ''}</p>
                <div class="product-modal-description">
                  <p>${product.modalDescription}</p>
                </div>
                <button class="product-modal-back" data-modal-close>Back to Chat</button>
              </div>
            </div>
          </div>
        </div>
      `;
this.insertAdjacentHTML('beforeend', modalHtml);
    }
  }
handleQuickStartClick(value) {
// Prevent clicks while AI is responding
if (this.isTyping) return;
// Disable all quick-start buttons
const buttons = this.querySelectorAll('.quick-start-btn');
buttons.forEach(btn => {
btn.disabled = true;
if (btn.dataset.value === value) {
btn.classList.add('selected');
      }
    });
// Convert empty state to message if needed
if (this.messages.length === 0) {
this.convertEmptyStateToMessage();
    }
// Send the selected value as user message
this.addMessage(value, 'user');
// Add to conversation history
this.conversationHistory.push({
role: 'user',
content: value
    });
// Get AI response
this.getAIResponse();
  }
updateEmptyStateClass() {
if (this.emptyState && this.emptyState.style.display !== 'none') {
this.messagesContainer.classList.add('empty-state-active');
    } else {
this.messagesContainer.classList.remove('empty-state-active');
    }
  }
autoResizeTextarea() {
const textarea = this.inputField;
textarea.style.height = 'auto';
const newHeight = Math.min(textarea.scrollHeight, 180);
textarea.style.height = newHeight + 'px';
// Only show scrollbar if content exceeds max height
if (newHeight >= 180) {
textarea.style.overflowY = 'auto';
    } else {
textarea.style.overflowY = 'hidden';
    }
this.sendButton.disabled = !textarea.value.trim();
  }
resetChat() {
this.messages = [];
this.conversationHistory = [];
// Generate new session ID on reset
this.sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
this.messagesContainer.innerHTML = `
      <div class="empty-state">
        <div class="empty-state-greeting">
          Welcome — let's find the right serum for your skin.
        </div>
        <div class="empty-state-question">
          What's your primary skin concern right now?
        </div>
        <div class="quick-start-buttons">
          <button class="quick-start-btn" data-value="Dullness / Dark spots">Dullness / Dark spots</button>
          <button class="quick-start-btn" data-value="Dryness / Dehydration">Dryness / Dehydration</button>
          <button class="quick-start-btn" data-value="Fine lines / Wrinkles">Fine lines / Wrinkles</button>
          <button class="quick-start-btn" data-value="Sensitive skin">Sensitive skin</button>
          <button class="quick-start-btn" data-value="General maintenance">General maintenance</button>
          <button class="quick-start-btn" data-value="Not sure">Not sure</button>
        </div>
        <div class="or-type-text">Or describe it in your own words below</div>
        <div class="expert-badge">
          <img src="/ai-profile.svg" alt="AI" width="28" height="28">
        </div>
      </div>
    `;
this.emptyState = this.querySelector('.empty-state');
this.inputField.value = '';
this.autoResizeTextarea();
this.hasInteracted = false;
this.updateEmptyStateClass();
// Dispatch custom event so React can update session ID display
this.dispatchEvent(new CustomEvent('session-reset', {
detail: { sessionId: this.sessionId },
bubbles: true
    }));
  }
async handleSendMessage() {
const message = this.inputField.value.trim();
if (!message) return;
// Prevent sending while AI is responding
if (this.isTyping) return;
if (this.messages.length === 0) {
this.convertEmptyStateToMessage();
// Fire GTM event for first prompt submission
if (typeof window !== 'undefined' && window.dataLayer) {
window.dataLayer.push({
event: 'aichat_prompt_submitted',
session_id: this.sessionId
        });
      }
    }
this.addMessage(message, 'user');
this.inputField.value = '';
this.autoResizeTextarea();
// Add user message to conversation history
this.conversationHistory.push({
role: 'user',
content: message
    });
await this.getAIResponse();
  }
convertEmptyStateToMessage() {
this.emptyState.style.display = 'none';
this.updateEmptyStateClass();
const openingMessage = "Welcome — let's find the right serum for your skin.\n\nWhat's your primary skin concern right now?";
const messageData = {
content: openingMessage,
sender: 'ai',
timestamp: new Date()
    };
this.messages.push(messageData);
this.renderMessage(messageData, false); // Don't add badge to message
// Move badge after the message
const lastMessage = this.messagesContainer.querySelector('.message.ai:last-child .message-content');
if (lastMessage && this.aiBadge) {
lastMessage.appendChild(this.aiBadge);
    }
// Add initial system message to conversation history
this.conversationHistory.push({
role: 'assistant',
content: openingMessage
    });
  }
addMessage(content, sender, recommendation = null) {
const messageData = {
content,
sender,
timestamp: new Date(),
recommendation
    };
this.messages.push(messageData);
const messageElement = this.renderMessage(messageData, true); // Always add badge for new messages
// Scroll behavior: for AI messages, show user's question + AI response
if (sender === 'ai') {
this.scrollToMessage(messageElement);
    } else {
this.scrollToBottom();
    }
  }
renderMessage(messageData, shouldMoveBadge = true) {
const messageElement = document.createElement('div');
messageElement.className = `message ${messageData.sender}`;
const content = document.createElement('div');
content.className = 'message-content';
if (messageData.sender === 'ai') {
// Check if this message has structured recommendation data (from tool calling)
if (messageData.recommendation && messageData.recommendation.products) {
// Render product cards from structured data
const productsHtml = this.renderProductCardsFromJson(
          { products: messageData.recommendation.products },
messageData.recommendation.intro,
messageData.recommendation.closing,
messageData.recommendation.review
        );
const wrapper = document.createElement('div');
wrapper.innerHTML = productsHtml;
content.appendChild(wrapper);
      } else if (messageData.content) {
// Check for legacy JSON code block format (fallback)
const jsonMatch = messageData.content.match(/```json\s*([\s\S]*?)\s*```/);
if (jsonMatch) {
const jsonData = this.tryParseJson(jsonMatch[1]);
if (jsonData) {
const beforeJson = messageData.content.substring(0, jsonMatch.index).trim();
const afterJson = messageData.content.substring(jsonMatch.index + jsonMatch[0].length).trim();
const productsHtml = this.renderProductCardsFromJson(jsonData, beforeJson, afterJson, null);
const wrapper = document.createElement('div');
wrapper.innerHTML = productsHtml;
content.appendChild(wrapper);
          } else {
// If JSON parsing fails, render as regular message
console.error('Failed to parse product JSON');
const text = document.createElement('div');
const formattedText = messageData.content.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
text.innerHTML = this.linkifyUrls(formattedText);
content.appendChild(text);
          }
        } else {
// Regular message
const text = document.createElement('div');
const formattedText = messageData.content.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
text.innerHTML = this.linkifyUrls(formattedText);
content.appendChild(text);
        }
      }
// Move the badge to this message
if (shouldMoveBadge && this.aiBadge) {
content.appendChild(this.aiBadge);
      }
    } else {
content.textContent = messageData.content;
    }
messageElement.appendChild(content);
this.messagesContainer.appendChild(messageElement);
return messageElement;
  }
renderProductCardsFromJson(jsonData, beforeText, afterText, reviewData = null) {
// Build intro text
const intro = beforeText || 'Here is my recommendation for you:';
// Build product cards HTML
let html = `<div class="product-cards-intro">${this.linkifyUrls(intro)}</div>`;
// Collect product data for GTM and rendering
const skus = [];
let productUrl = '';
let variantId = '';
if (jsonData.products && Array.isArray(jsonData.products)) {
jsonData.products.forEach(product => {
const productData = getProductData(product.name);
if (productData.sku) {
skus.push(productData.sku);
        }
if (productData.productUrl) {
productUrl = productData.productUrl;
        }
if (productData.variantId) {
variantId = productData.variantId;
        }
// Fire GTM event for product recommendation
if (typeof window !== 'undefined' && window.dataLayer) {
window.dataLayer.push({
event: 'aichat_skus_recommended',
product_skus: skus,
product_count: jsonData.products.length,
session_id: this.sessionId
          });
        }
const imageUrl = productData.imageUrl || `/product-images/${this.slugify(product.name)}.jpg`;
html += `
          <div class="product-card"
               data-product-info-trigger="${productData.handle || ''}"
               style="cursor: pointer;">
            <div class="product-card-image">
              <img src="${imageUrl}" alt="${productData.name}" onerror="this.style.display='none'">
            </div>
            <div class="product-card-content">
              <h3 class="product-name">${productData.name}</h3>
${productData.price ? `<div class="product-price">${productData.price}</div>` : ''}
              <div class="product-description">
${product.description}
              </div>
              <a class="product-learn-more" href="#">LEARN MORE</a>
            </div>
          </div>
        `;
      });
    }
// Add closing text
if (afterText) {
html += `<div class="product-cards-footer">${this.linkifyUrls(afterText)}</div>`;
    }
// Add to Cart — renders a Shopify-compatible form that <cart-drawer> intercepts
if (variantId) {
html += `
        <form action="/cart/add" method="post" class="chat-atc-form"
              data-product-url="${productUrl}"
              data-product-skus='${JSON.stringify(skus)}'>
          <input type="hidden" name="id" value="${variantId}">
          <input type="hidden" name="quantity" value="1">
          <button type="submit" name="add"
                  class="add-bundle-btn ajax-submit action_button button--add-to-cart"
                  data-add-to-cart-trigger
                  data-label="Add to Cart">
            ADD TO CART
          </button>
        </form>
      `;
    }
// Look up review from PRODUCT_DATA (widget-side, not from API)
const product = jsonData.products && jsonData.products[0];
const review = product ? getProductData(product.name).review : null;
if (review) {
html += `
        <div class="review-card">
          <div class="review-header">
            <div class="review-rating">
${'★'.repeat(5)}
            </div>
            <div class="review-meta">
              <span class="review-author">${this.escapeHtml(review.reviewer_name || 'Anonymous')}</span>
${/* review.skin_type ? `<span class="review-skin-type">${this.escapeHtml(review.skin_type)}</span>` : '' */ ''}
            </div>
          </div>
${review.review_title ? `<div class="review-title">${this.escapeHtml(review.review_title)}</div>` : ''}
          <div class="review-content">${this.escapeHtml(review.review_content)}</div>
${product ? `<div class="review-product">Review for: ${this.escapeHtml(getProductData(product.name).name)}</div>` : ''}
        </div>
      `;
    }
return html;
  }
escapeHtml(text) {
if (!text) return '';
// First decode any HTML entities that might be in the text
const textarea = document.createElement('textarea');
textarea.innerHTML = text;
let decoded = textarea.value;
// Escape special HTML characters for safe rendering
const escaped = decoded
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
// Convert newlines to <br> tags
return escaped.replace(/\n/g, '<br>');
  }
slugify(text) {
return text.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
tryParseJson(jsonString) {
// First try strict parsing
try {
return JSON.parse(jsonString);
    } catch (e) {
// Try to repair common errors
let repaired = jsonString
// Fix array closed with } instead of ]
        .replace(/(\])\s*\}\s*\}\s*$/, '$1}')
        .replace(/\}\s*\}\s*$/, '}]');
try {
return JSON.parse(repaired);
      } catch (e2) {
return null;
      }
    }
  }
showTypingIndicator() {
if (this.isTyping) return;
this.isTyping = true;
// Disable send button while AI is responding
this.sendButton.disabled = true;
const typingElement = document.createElement('div');
typingElement.className = 'typing-indicator-container';
typingElement.setAttribute('data-typing', 'true');
// Move the badge here and add spinning class
if (this.aiBadge) {
this.aiBadge.classList.add('spinning');
typingElement.appendChild(this.aiBadge);
    }
this.messagesContainer.appendChild(typingElement);
this.scrollToBottom();
  }
hideTypingIndicator() {
const typingElement = this.messagesContainer.querySelector('[data-typing="true"]');
if (typingElement) {
// Remove spinning class
if (this.aiBadge) {
this.aiBadge.classList.remove('spinning');
      }
typingElement.remove();
    }
this.isTyping = false;
// Re-enable send button based on input content
this.autoResizeTextarea();
  }
async getAIResponse() {
this.showTypingIndicator();
try {
const endpoint = 'https://sbs-ai-chat.vercel.app/api/chat';
// Build request body (system prompt is now in the API endpoint)
const requestBody = {
messages: this.conversationHistory,
sessionId: this.sessionId,
metadata: {
source: 'web_component',
environment: 'production'
        }
      };
const response = await fetch(endpoint, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
        },
body: JSON.stringify(requestBody)
      });
if (!response.ok) {
throw new Error(`HTTP error! status: ${response.status}`);
      }
const data = await response.json();
this.hideTypingIndicator();
if (data.error) {
this.showErrorMessage(data.error);
      } else {
this.addMessage(data.text, 'ai', data.recommendation);
// Add AI response to conversation history
// If there's text, add it. If there's a recommendation but no text,
// create a summary for context in follow-up questions
if (data.text && data.text.trim().length > 0) {
this.conversationHistory.push({
role: 'assistant',
content: data.text
          });
        } else if (data.recommendation) {
// Create a summary of the recommendation for conversation context
const productNames = data.recommendation.products.map(p => p.name).join(', ');
const summary = `I recommended: ${productNames}. ${data.recommendation.intro || ''} ${data.recommendation.closing || ''}`;
this.conversationHistory.push({
role: 'assistant',
content: summary.trim()
          });
        }
      }
    } catch (error) {
console.error('Error calling AI API:', error);
this.hideTypingIndicator();
this.showErrorMessage('Sorry, I\'m having trouble connecting right now. Please try again in a moment.');
    }
  }
showErrorMessage(message) {
const errorElement = document.createElement('div');
errorElement.className = 'error-message';
errorElement.textContent = message;
this.messagesContainer.appendChild(errorElement);
this.scrollToBottom();
  }
scrollToMessage(messageElement) {
setTimeout(() => {
// Find the previous message (user's question)
const previousMessage = messageElement.previousElementSibling;
const targetElement = (previousMessage && previousMessage.classList.contains('user'))
? previousMessage
: messageElement;
// Calculate scroll position relative to the messages container
const containerTop = this.messagesContainer.offsetTop;
const elementTop = targetElement.offsetTop;
const scrollPosition = elementTop - containerTop;
// Scroll the messages container, not the page
this.messagesContainer.scrollTo({
top: scrollPosition,
behavior: 'smooth'
      });
    }, 100);
  }
scrollToBottom() {
setTimeout(() => {
this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
    }, 100);
  }
linkifyUrls(text) {
// Convert URLs to clickable links
// Stop at whitespace, angle brackets (HTML tags), or common punctuation at end of sentences
const urlPattern = /(https?:\/\/[^\s<]+)/g;
return text.replace(urlPattern, (url) => {
// Remove trailing punctuation that's likely not part of the URL
const cleanUrl = url.replace(/[.,;:!?]+$/, '');
return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" style="color: #000; text-decoration: underline;">${cleanUrl}</a>`;
    });
  }
}
customElements.define('sbs-chat', HairChat);